import { Heading, TextTypes } from "@sede-x/shell-ds-react-framework";
const HeaderDescription = ({ descriptiontxt }: { descriptiontxt: string }) => {
  return (
    <Heading type={TextTypes.H4} className={"common-header-description"}>
      {descriptiontxt}
    </Heading>
  );
};
export default HeaderDescription;
